import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEnglish from "./languages/english.json";
import translationFrench from "./languages/french.json";
import translationPortuguese from "./languages/portuguese.json";
import translationSwc from "./languages/swc.json";

const resources = {
  1: {
    translation: translationEnglish,
  },
  /* 2: {
        translation: translationFrench
    },
    3: {
        translation: translationPortuguese
    },*/
  2: {
    translation: translationSwc,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "2",
  interpolation: {
    escapeValue: false, // react already escapes values
  },
});

export default i18n;
